import React from 'react';
import "../assets/css/campusambassador.css";
import Footer from "./footer";

function CampusAmbassador() {
    const students = [
        {
            name: "Ashwanth Dhanish M",
            location: "Mangalore, India",
            institute: "Mangalore Institute Technology of Engineering",
            id: "16AE010",
            img: "https://campushunt.in/images/campus_ambadassor/ashwanth.jpg"
        },
        {
            name: "Jishnu P",
            location: "Mangalore, India",
            institute: "Krupanadhi School of Management",
            id: "001507",
            img: "https://campushunt.in/images/campus_ambadassor/jishnu.jpg"
        },
        {
            name: "Abdul najeeb kv",
            location: "Kerala, India",
            institute: "SJB College of Management Studies",
            id: "176FC26001",
            img: "https://campushunt.in/images/campus_ambadassor/mohammed.jpg"
        },
        {
            name: "Mohammed Afnan F",
            location: "Bangalore, India",
            institute: "East Point College of Nursing",
            id: "17N3229",
            img: "https://campushunt.in/images/campus_ambadassor/najeeb.jpg"
        },
        {
            name: "Ashiq ali P",
            location: "Bangalore, India",
            institute: "Krupanadhi School of Management",
            id: "17MBA-BU0103",
            img: "https://campushunt.in/images/campus_ambadassor/ashiq.jpg"
        },
        {
            name: "Mohammed Yusuf",
            location: "Kerala, India",
            institute: "Brindavan College of Engineering",
            id: "578EC17003",
            img: "https://campushunt.in/images/campus_ambadassor/yusuf.jpg"
        },
        {
            name: "Jobin Joseph",
            location: "Kottayam, India",
            institute: "N.R.I. Institute",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/jobin.jpg"
        },
        {
            name: "Devarapalli Gonourbasha",
            location: "Bangalore, India",
            institute: "Krupanadhi School of Management",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/devarapalli-gonourbasha.jpg"
        },
        {
            name: "Muhammed Shamal N",
            location: "Kerala, India",
            institute: "Brindavan College of Engineering",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/muhammed-shamal-n.jpg"
        },
        {
            name: "Lelvin Savio Rodriguez",
            location: "Goa, India",
            institute: "Hillside Business School",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/lelvin-savio-rodriguez.jpg"
        },
        {
            name: "Mohammed",
            location: "Kerala, India",
            institute: "MS Ramaia",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/313911545363834033.jpg"
        },
        {
            name: "Pranav Babu",
            location: "Kerala, India",
            institute: "Shri Devi Institute of Technology",
            id: "4TH16MBA50",
            img: "https://campushunt.in/images/campus_ambadassor/3510072953693581405.jpg"
        },
        {
            name: "Hanzalah Naeem Chikte",
            location: "Mumbai, India",
            institute: "Koshys Institute of Management Studies",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/Hanzalah.jpg"
        },
        {
            name: "Sandra",
            location: "Kerala, India",
            institute: "East Point College of Nursing",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/Sandra.jpg"
        },
        {
            name: "Sradha",
            location: "Kerala, India",
            institute: "East Point College of Nursing",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/Sradha.jpg"
        },
        {
            name: "Sewani",
            location: "Nepal",
            institute: "SJB Institute of Management",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/Sewani.jpg"
        },
        {
            name: "Nithin Charlie",
            location: "Kerala, India",
            institute: "Impact Institute of Management",
            id: "2017-20",
            img: "https://campushunt.in/images/campus_ambadassor/Nithin-Charlie.jpg"
        }
    ];



    return (
        <div className='mainnav-container'>
            <div className='imgamb-st'>
                <div className='imgcontainer-st'>
                    <h3 className='header-ambst'> Want to become a CampusHunt Student Ambassador? Join the CampusHunt Student Ambassador (CSA) Program Today!</h3>
                    <div className='secdivconatiner-st'>
                        <div className='listpage-st'>
                            <ul className='ullistpage-st'>
                                <li>An opportunity for students to act as an associate between CampusHunt and their universities, the CSA program aims to help students learn about innovative products and services offered by CampusHunt.</li>
                                <li>Plan and host fun events on campus, act as a campus contact for CampusHunt team and help CampusHunt better understand each College's culture and life.</li>
                                <li>Through the program, ambassadors will have the opportunity to enhance their professional development, leadership qualities, communication skills and access to unique network of other CampusHunt ambassadors across the Nation.</li>
                                <li>The program is offered in multiple regions around India, application deadline for South India (Maharashtra, Goa, Karnataka, Tamilnadu and Kerala) is June 3, 2018.</li>
                                <li>For Rest of India (Northern India and Central India) the deadline will be July 6, 2018.</li>
                            </ul>
                        </div>
                        <div className='listpage-st'>
                            <div className="ambform_wrapper">
                                <div className="ambform_container">
                                    <h3 className="ambform_title">Apply Now for CSA</h3>
                                    <hr className="ambform_line" />
                                    <form className="ambform_form">
                                        <label className="ambform_label">Name *</label>
                                        <input className="ambform_input" type="text" placeholder="Enter Name" />

                                        <label className="ambform_label">Email *</label>
                                        <input className="ambform_input" type="email" placeholder="Enter Email" />

                                        <label className="ambform_label">Contact No. *</label>
                                        <input className="ambform_input" type="text" placeholder="Enter Contact No" />

                                        <label className="ambform_label">College Name *</label>
                                        <input className="ambform_input" type="text" placeholder="Enter College Name" />

                                        <div className="ambform_row">
                                            <div className="ambform_col">
                                                <label className="ambform_label">Student ID *</label>
                                                <input className="ambform_input" type="text" placeholder="Enter Student ID" />
                                            </div>

                                            <div className="ambform_col">
                                                <label className="ambform_label">User Photo *</label>
                                                <input className="ambform_input" type="file" />
                                            </div>
                                        </div>

                                        <button className="ambform_btn" type="submit">
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="imgamb-st mt-0">

                <div className="ambform_grid">
                    <div className="ambform_box">
                        <div className="ambform_box_title">Eligibility</div>

                        <div className="ambform_box_content">
                            <ul className='elpage-st'>
                                <li>
                                    Should have enrolled in full-time undergraduate/postgraduate
                                    study in any discipline.
                                </li>

                                <li>
                                    Available for Physical or Virtual Meeting with CampusHunt Team
                                    once in a month.
                                </li>

                                <li>
                                    Familiar with Colleges, Courses, Specialisations etc in the
                                    city and willingness to suggest the best fit for Upcoming
                                    students.
                                </li>

                                <li>An active Social media and Internet user.</li>

                                <li>Involved with student organizations and activities.</li>

                                <li>
                                    Ability to make Teams, Leadership, Convincing, Marketing,
                                    Motivating Behaviour.
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="ambform_box">
                        <div className="ambform_box_title">Duties</div>

                        <div className="ambform_box_content">
                            <ul className='elpage-st'>
                                <li>
                                    Interact with students at your Campus to promote CampusHunt
                                    services, help them search and apply for their dream campus.
                                </li>

                                <li>
                                    Educate the students about campushunt portal and its benefits.
                                </li>

                                <li>
                                    Act as a single point of contact for all Campaigns, Events and
                                    Meetings of CampusHunt.
                                </li>

                                <li>
                                    Help new students at your Campus to keep them safe from any
                                    kind of ragging or similar humiliations.
                                </li>

                                <li>
                                    Enhance students to write honest reviews of your college at
                                    CampusHunt Portal.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="ambform_box">
                    <div className="ambform_box_title">Benifits</div>
                    <div className="ambform_box_content">
                        <ul className='elpage-st'>
                            <li>Monetary Reward through referral programs.</li>
                            <li>Assured Internship program in your core field or with CampusHunt</li>
                            <li>Entrepreneurship Enhancement program - 1 week workshop every year for those who are planning to make a change in the world with a smart idea and Start-up.</li>
                            <li>Entry level support to Selected Team of Start-ups with free Office space and basic amenities allocation for 6 months with Technology and seed capital support.</li>
                            <li>Attractive tour packages for the best awarded CSA Team.</li>
                            <li>High end support for all CSAs for Recruitment/Placement with more Interview arrangements in their core field after the course completion.</li>
                            <li>Part time job option for all CSAs with CampusHunt to fund for their higher studies by themselves.</li>
                        </ul>
                    </div>
                </div>

                <div style={{ marginTop: "82px" }} className="ambform_box_title">Campushunt Ambadassor</div>
                <div className="students-container">
                    {students.map((student, index) => (
                        <div className="student-card" key={index}>
                            <div className="student-img">
                                <img className='w-100 h-100' src={student.img} alt={student.name} />
                            </div>

                            <div className="student-info">
                                <h3>{student.name}</h3>
                                <p>{student.location}</p>
                                <p><strong>Institute :</strong> {student.institute}</p>
                                <p><strong>{index < 5 ? 'Student ID' : 'Batch'} :</strong> {student.id}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default CampusAmbassador;
